import * as types from '../actions/types';
import initialState from './initialState';



export default function runsReducer(state = initialState.runs, action) {
  switch (action.type) {
    case types.RUNS_FETCHED:
      return [
        ...action.payload
      ];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/runsReducer.js